import React from 'react';
import { Link } from 'react-router-dom';
import Footer from './Footer';

function ContentPageLayout({ children, title, subtitle, showBackButton = false }) {
  return (
    <div className="content-page-layout min-vh-100 d-flex flex-column">
      <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm sticky-top">
        <div className="container">
          <Link className="navbar-brand d-flex align-items-center" to="/">
            <img src="/logo.png" alt="EduSpace Logo" style={{ height: '40px' }} />
            <span className="ms-2 fw-bold text-primary">EduSpace</span>
          </Link>
          <div className="d-flex align-items-center">
            <Link to="/" className="btn btn-outline-primary me-2">
              <i className="fas fa-home me-1"></i> Home
            </Link>
            <Link to="/login" className="btn btn-primary">
              <i className="fas fa-sign-in-alt me-1"></i> Login
            </Link>
          </div>
        </div>
      </nav>

      <main className="flex-grow-1 py-4">
        <div className="container">
          {(title || subtitle) && (
            <div className="text-center mb-5 py-4">
              {showBackButton && (
                <button 
                  onClick={() => window.history.back()} 
                  className="btn btn-link mb-3"
                >
                  <i className="fas fa-arrow-left me-2"></i> Back
                </button>
              )}
              {title && <h1 className="display-5 fw-bold mb-3">{title}</h1>}
              {subtitle && <p className="lead text-muted">{subtitle}</p>}
            </div>
          )}
          {children}
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default ContentPageLayout;